var render = function render(_c,_vm){return _c('div',{staticClass:"mapping-item"},[_vm._v(_vm._s(_vm.props.item.label)+" "),_c('i',{staticClass:"el-icon-right"}),_vm._v(" "+_vm._s(_vm._f("field")(_vm.props.item.field,_vm.props.dicts)))])
}
var staticRenderFns = []

export { render, staticRenderFns }